// extracted by mini-css-extract-plugin
export default {"root":"ProductModelInfo__root___mWreh","name":"ProductModelInfo__name___mV_AC","description":"ProductModelInfo__description___brW8j"};